(() => {
  const instances = new Map();

  class CtrListicleFaqs {
    constructor(section) {
      this.section = section;
      this.sectionId = section.dataset.sectionId || "";
      this.items = Array.from(section.querySelectorAll("[data-ctr-faq-item]"));
      this.allowMultiple = section.dataset.allowMultiple === "true";

      this.handleQuestionClick = this.handleQuestionClick.bind(this);
      this.onBlockSelect = this.onBlockSelect.bind(this);

      this.bind();
      this.syncHeights();
    }

    bind() {
      this.items.forEach((item) => {
        const button = item.querySelector("[data-ctr-faq-toggle]");
        if (!button) return;
        button.addEventListener("click", this.handleQuestionClick);
      });

      document.addEventListener("shopify:block:select", this.onBlockSelect);
    }

    handleQuestionClick(event) {
      event.preventDefault();
      const item = event.currentTarget.closest("[data-ctr-faq-item]");
      if (!item) return;

      const isOpen = item.classList.contains("is-open");

      if (!this.allowMultiple) {
        this.items.forEach((otherItem) => {
          if (otherItem === item) return;
          this.closeItem(otherItem);
        });
      }

      if (isOpen) {
        this.closeItem(item);
        return;
      }

      this.openItem(item);
    }

    onBlockSelect(event) {
      const detail = event.detail || {};
      if (detail.sectionId !== this.sectionId || !detail.blockId) return;

      const item = this.items.find((entry) => entry.dataset.blockId === detail.blockId);
      if (!item) return;

      if (!this.allowMultiple) {
        this.items.forEach((otherItem) => {
          if (otherItem === item) return;
          this.closeItem(otherItem);
        });
      }

      this.openItem(item);
    }

    openItem(item) {
      const button = item.querySelector("[data-ctr-faq-toggle]");
      const answer = item.querySelector("[data-ctr-faq-answer]");
      if (!button || !answer) return;

      item.classList.add("is-open");
      button.setAttribute("aria-expanded", "true");
      answer.style.maxHeight = `${answer.scrollHeight}px`;
    }

    closeItem(item) {
      const button = item.querySelector("[data-ctr-faq-toggle]");
      const answer = item.querySelector("[data-ctr-faq-answer]");
      if (!button || !answer) return;

      item.classList.remove("is-open");
      button.setAttribute("aria-expanded", "false");
      answer.style.maxHeight = null;
    }

    syncHeights() {
      this.items.forEach((item) => {
        if (!item.classList.contains("is-open")) return;
        const answer = item.querySelector("[data-ctr-faq-answer]");
        if (!answer) return;
        answer.style.maxHeight = `${answer.scrollHeight}px`;
      });
    }

    destroy() {
      this.items.forEach((item) => {
        const button = item.querySelector("[data-ctr-faq-toggle]");
        if (!button) return;
        button.removeEventListener("click", this.handleQuestionClick);
      });

      document.removeEventListener("shopify:block:select", this.onBlockSelect);
    }
  }

  const init = (root) => {
    const section = root?.querySelector?.(".ctr-listicle-faqs") || root;
    if (!section || !section.matches(".ctr-listicle-faqs")) return;
    if (instances.has(section)) return;
    instances.set(section, new CtrListicleFaqs(section));
  };

  const unload = (root) => {
    const section = root?.querySelector?.(".ctr-listicle-faqs") || root;
    if (!section || !section.matches(".ctr-listicle-faqs")) return;
    const instance = instances.get(section);
    if (!instance) return;
    instance.destroy();
    instances.delete(section);
  };

  const initAll = () => {
    document.querySelectorAll(".ctr-listicle-faqs").forEach((section) => init(section));
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", (event) => init(event.target));
  document.addEventListener("shopify:section:unload", (event) => unload(event.target));
  document.addEventListener("shopify:section:reorder", initAll);
})();
